export const ApplicationTypeConstants = {
  TROOPER_ID : 1,
  AUXILIARY_ID: 2,

}
